/** Distance from the viewport left edge — leaves room for the left toolbar. */
export const DOCK_LEFT = 60;

/** Default width of the dock column. Matches the floating window default width. */
export const DOCK_PANEL_WIDTH = 352;

/** Minimum width the dock column can be dragged to. */
export const DOCK_MIN_WIDTH = 250;

/** Maximum width the dock column can be dragged to. */
export const DOCK_MAX_WIDTH = 600;

/** Vertical inset from the top/bottom of the render container. */
export const DOCK_EDGE_MARGIN = 8;

/** Gap between docked window slots. */
export const DOCK_PANEL_GAP = 8;

/**
 * Fixed height of a minimized slot (header only).
 *
 * This is the default for first-party windows. SDK windows can override at
 * runtime via measured `state.dockedMinimizedHeight`.
 */
export const DOCK_MINIMIZED_HEIGHT = 58;

/** Minimum pinned height a slot can be dragged to. */
export const DOCK_MIN_HEIGHT = 120;

/**
 * Slack (px) below a flex slot's equal-share height before a docked window is
 * treated as "self-collapsed". Third-party windows can force their own rendered
 * height (e.g. an SDK collapsing to a header) well under the space the layout
 * hands them; when the measured `dockedContentHeight` falls this far short of
 * the flex share, the window is pinned to its measured height so it never holds
 * space it isn't painting. Genuine flex windows are geometry-locked to the slot
 * and measure ≈ the share, so they stay within the tolerance and keep flexing.
 */
export const DOCK_SELF_COLLAPSE_TOLERANCE = 16;

/** Height of the bottom-edge resize handle's hit area. */
export const DOCK_RESIZE_HANDLE_HEIGHT = 6;

/** Dock container z-index — above the canvas, below floating windows. */
export const DOCK_Z_INDEX = 1100;

/**
 * Floor for floating-window `state.zIndex`. The reducer's `reorderWindows`
 * assigns `BASE_FLOATING_Z_INDEX + n` so every floating panel — Settings, any
 * undocked window, anything dragged out of the dock — always renders above
 * `DOCK_Z_INDEX`.
 */
export const BASE_FLOATING_Z_INDEX = DOCK_Z_INDEX + 100;
